import type { ChangeEvent, CSSProperties, ReactElement, RefObject } from 'react';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Ctext } from '../Ctext';
import { CTEXTINPUT_DEFAULT_FONT_SIZE_PX, CtextinputAutoComplete, CtextinputDataName, CtextinputInputType, } from './Ctextinput.constants';
import type { CtextinputElement, CtextinputProps } from './Ctextinput.types';
interface CtextinputFieldProps {
    autoFocus: boolean;
    disabled: boolean;
    fieldContentStyle: CSSProperties;
    id?: string;
    inputBaseStyle: CSSProperties;
    inputRef: RefObject<CtextinputElement | null>;
    isMultiLine: boolean;
    name?: string;
    onBlur: () => void;
    onChange: (event: ChangeEvent<CtextinputElement>) => void;
    onFocus: () => void;
    onKeyDown?: CtextinputProps['onKeyDown'];
    onScroll?: CtextinputProps['onScroll'];
    placeholder: string;
    rows: number;
    textOpacity: number;
    textareaHeight?: string;
    value: string;
}
export function CtextinputField({ autoFocus, disabled, fieldContentStyle, id, inputBaseStyle, inputRef, isMultiLine, name, onBlur, onChange, onFocus, onKeyDown, onScroll, placeholder, rows, textOpacity, textareaHeight, value, }: CtextinputFieldProps): ReactElement {
    return (
	<Ctext size={CTEXTINPUT_DEFAULT_FONT_SIZE_PX} weight={FontWeight.Light} color={ColorType.White} opacity={textOpacity} style={fieldContentStyle}>
      {isMultiLine ? (<textarea ref={inputRef as RefObject<HTMLTextAreaElement>} id={id} name={name} autoComplete={CtextinputAutoComplete.Off} autoFocus={autoFocus} value={value} onChange={onChange} onFocus={onFocus} onBlur={onBlur} onKeyDown={onKeyDown} onScroll={onScroll} placeholder={placeholder} disabled={disabled} rows={rows} style={{
                ...inputBaseStyle,
                height: textareaHeight,
            }}/>) : (<input ref={inputRef as RefObject<HTMLInputElement>} id={id} name={name} type={CtextinputInputType.Text} autoComplete={CtextinputAutoComplete.Off} autoFocus={autoFocus} value={value} onChange={onChange} onFocus={onFocus} onBlur={onBlur} onKeyDown={onKeyDown} placeholder={placeholder} disabled={disabled} style={inputBaseStyle}/>)}
    </Ctext>
    );
}
